'use strict';

import { getSearchParams, isMobileDevice } from './site';

// _isCallCenterOpen() will return whether the Call Center is currently open
function isCallCenterOpen() {
  const d = new Date().toLocaleString("en-US", { timeZone: "America/Chicago" });
  const hours = d.getHours();
  const minutes = d.getMinutes();
  const day = d.getDay();

  // On Monday and Tuesday, the Call Center is open between 8:00a and 7:00p
  if (day === 1 || day === 2) {
    return day >= 1 && day <= 6 && hours >= 8 && hours <= 19;
  }

  // On Wednesday, the Call Center is open between 8:00a and 5:30p
  if (day === 3) {
    return (
      day >= 1 &&
      day <= 6 &&
      hours >= 8 &&
      (hours < 17 || (hours === 17 && minutes <= 30))
    );
  }

  // On Thursday and Friday, the Call Center is open between 8:00a and 7:00p
  if (day === 4 || day === 5) {
    return day >= 1 && day <= 6 && hours >= 8 && hours <= 19;
  }

  // On Saturday, the Call Center is open between 8:00a and 2:30p
  if (day === 6) {
    return (
      day >= 1 &&
      day <= 6 &&
      hours >= 8 &&
      (hours < 14 || (hours === 14 && minutes <= 30))
    );
  }

  // else, the Call Center is closed
  return false;
}

// triggerVisitorEngagementPrompt() runs all necessary logic to handle triggering a visitor engagement prompt
export function triggerVisitorEngagementPrompt() {
  if(typeof document === "undefined") return;

  if(!isMobileDevice() || !isCallCenterOpen()) return;

  const _urlParams = getSearchParams();
  let referredBy = !!_urlParams['Referred_By'] ? _urlParams['Referred_By'] : '';

  // when the site loads, immediately trigger a visitor engagement prompt
  document.getElementById("tel_btn").click();

  // // when the site loads, immediately trigger a visitor engagement prompt
  // if (!!referredBy && referredBy === "google_ad") // if this page visit was referred by Google Ad
  // {
  //   // when the site loads, immediately trigger a visitor engagement prompt
  //   document.getElementById("tel_btn").click();
  //
  //   // // after the visitor's first interaction with the site (scroll, click, etc.), trigger a visitor engagement prompt
  //   //
  //   // // scroll event
  //   // $("body").on("scroll", function (event) {
  //   //     document.getElementById("tel_btn").click();
  //   // });
  //   //
  //   // // click event
  //   // $("body").on("click", function (event) {
  //   //     document.getElementById("tel_btn").click();
  //   // });
  //   //
  //   // // web inquiry form field click event
  //   // $("form#contact_form input, form.contact_form textarea").on(
  //   //     "click",
  //   //     function (event) {
  //   //         document.getElementById("tel_btn").click();
  //   //     }
  //   // );
  //   //
  //   // // locations dropdown click event
  //   // $("select#Locations_Dropdown").on("click", function (event) {
  //   //     document.getElementById("tel_btn").click();
  //   // });
  //   //
  //   // // web inquiry form submitted event
  //   // if ($(".sidebar-success-notification").is(":visible")) {
  //   //     document.getElementById("tel_btn").click();
  //   // }
  // }
  // else if (!!referredBy && referredBy === "marketing_email") // if this page visit was referred by Marketing Email
  // {
  //   document.getElementById("tel_btn").click();
  // }
  // else // if not referred by Google Ad or Marketing Email, we consider this page visit to be "Organic"
  // {
  //   document.getElementById("tel_btn").click();
  // }
}

export function activateTextOrCallLinks(phoneNumVal = "") {
  if(typeof document === "undefined") return;

  try {
    const locationPhoneNumber = (!!phoneNumVal) ? "" : document.getElementById('Current_Location_Phone_Num_Val');
    const locationPhoneNum = ( (phoneNumVal === "")
      && ((!!locationPhoneNumber
        && typeof locationPhoneNumber === "object"
        && "value" in locationPhoneNumber))
    ) ? `${locationPhoneNumber?.value}` : `${phoneNumVal}`;

    if(!!locationPhoneNum) {
      const textPhoneNumLinks = document.querySelectorAll('.text_phone_num_link');
      if(textPhoneNumLinks?.length > 0) {
        const textContent = "I need an excellent attorney!";
        const textMessageBody = encodeURIComponent(textContent).replace(/!/g, '%21') // Exclamation mark is not encoded by javascript
        const newTextablePhoneLinkHTML = `<a id="tel_btn" href="sms://${locationPhoneNum.replace(/-/g, "")};?&body=${textMessageBody}" style="color: unset !important;text-decoration: none;">Text</a>`
        textPhoneNumLinks.forEach((textablePhoneLink) => {
          textablePhoneLink.innerHTML = newTextablePhoneLinkHTML;
        });
      }

      const callPhoneNumLinks = document.querySelectorAll('.call_phone_num_link');
      if(callPhoneNumLinks?.length > 0) {
        const newCallablePhoneLinkHTML = `<a id="tel_btn" href="tel:+1-${locationPhoneNum}" style="color: unset !important;text-decoration: none;">Call</a>`
        callPhoneNumLinks.forEach((callablePhoneLink) => {
          callablePhoneLink.innerHTML = newCallablePhoneLinkHTML;
        });
      }
    }
  } catch(e) {
    e = null
  }
}

export function bindLocationsDropdown() {
  if(typeof document === "undefined") return;
  try {
    const locationsDropdown = document.getElementById('Locations_Dropdown');
    locationsDropdown?.addEventListener('change',function() {
      const newPhoneNumVal = `${this?.value || ""}`?.replace(/\|/g, ""); // these options have a pipe character so get rid of it
      activateTextOrCallLinks(newPhoneNumVal);
    });
  } catch(e) {
    e = null;
  }
}

// <a id="tel_btn" href="sms://  ${phoneNum}   ;?&body=I%20need%20an%20excellent%20attorney%21">    ${phoneNum}   </a>
// <a id="tel_btn" href="tel:+1-  ${phoneNum}  ">  ${phoneNum}  </a>

// Call is a Telephone Call at all times of the day
// Text is a Text Message at all times of the day
// Phone Number is a Telephone Call during office hours, and a Text Message during non office hours

// Outside business hours, visitor engagement is always a Text Message
// During business hours, visitor engagement